import {
  LangChangeEvent,
} from '@ngx-translate/core';
import {
  LocalizationService,
} from '@o3r/localization';
import {
  distinctUntilChanged,
  map,
  startWith,
} from 'rxjs/operators';

/**
 * Returns a method which takes the localization service as parameter and returns the language
 */
export const retrieveLanguage = () => (localizationService?: LocalizationService) =>
  localizationService?.getTranslateService().onLangChange.pipe(
    map((langChangeEvent: LangChangeEvent) => langChangeEvent.lang),
    startWith((localizationService?.getCurrentLanguage())),
    distinctUntilChanged()
  );
